var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-item",class:_vm.unitClass,style:(_vm.computedStyle)},[_c('div',{class:{ debug: _vm.gridMetrics.debug, error: !_vm.validInputs },attrs:{"dir":_vm.alignment === 'auto' ? 'auto' : null}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }